// 案件タブ（カンバン・一覧・アーカイブ）が共有する表示用の派生データ。判定そのものは lib/giftingRules が正本。
import type { AffAffiliate, GfAutoEvent, GfCampaign, GfCreator, GfData, GfEntry } from "../../../../types/gifting";
import {
  SOURCE_LABEL,
  STAGE_NAMES,
  affiliateByInfluencer,
  fmtMD,
  handleOf,
  mediaChip,
  primarySns,
  resolveRate,
  termsLabel,
} from "../../../../lib/giftingRules";

export interface PipelineCtx {
  nowIso: string;
  creators: Map<string, GfCreator>;
  campaigns: Map<string, GfCampaign>;
  affByInfluencer: Map<string, AffAffiliate>;
  /** deal id → 直近の source≠manual な段階変化（board.recent_auto_events＝直近24時間） */
  autoByDeal: Map<string, GfAutoEvent>;
}

export function buildPipelineCtx(data: GfData, nowIso: string): PipelineCtx {
  const autoByDeal = new Map<string, GfAutoEvent>();
  for (const ev of data.board.recent_auto_events) {
    if (ev.source === "manual") continue;
    const cur = autoByDeal.get(ev.deal_id);
    if (!cur || ev.created_at > cur.created_at) autoByDeal.set(ev.deal_id, ev);
  }
  return {
    nowIso,
    creators: new Map(data.board.creators.map((c) => [c.id, c])),
    campaigns: new Map(data.board.campaigns.map((c) => [c.id, c])),
    affByInfluencer: data.affiliates.status === "ok" ? affiliateByInfluencer(data.affiliates.data) : new Map(),
    autoByDeal,
  };
}

export interface CardInfo {
  creatorName: string;
  handle: string;
  campaignName: string;
  campaign: GfCampaign | null;
  /** 例: ¥5万 ＋ 15% */
  terms: string;
  /** 例: ["IG 12.4万", "YT 3.1万"]（フォロワー多い順に最大2つ） */
  media: string[];
  /** 自動検知バッジの文言（無ければ null） */
  autoText: string | null;
  autoTitle: string | null;
}

export function cardInfo(e: GfEntry, ctx: PipelineCtx): CardInfo {
  const creator = ctx.creators.get(e.influencer_id) ?? null;
  const campaign = e.campaign_id ? ctx.campaigns.get(e.campaign_id) ?? null : null;
  const rate = resolveRate(ctx.affByInfluencer.get(e.influencer_id), campaign);
  const sns = creator ? [...creator.sns].sort((a, b) => (b.follower_count ?? -1) - (a.follower_count ?? -1)) : [];
  const ev = e.stage < 8 ? ctx.autoByDeal.get(e.id) ?? null : null;
  return {
    creatorName: creator?.name ?? "（不明）",
    handle: handleOf(creator ? primarySns(creator.sns) : null),
    campaignName: campaign?.name ?? e.product_name,
    campaign,
    terms: termsLabel(e, campaign, rate),
    media: sns.slice(0, 2).map((s) => mediaChip(s.platform, s.follower_count)),
    autoText: ev ? `${SOURCE_LABEL[ev.source]}：${STAGE_NAMES[ev.to_stage] ?? ""} ${fmtMD(ev.created_at)}` : null,
    autoTitle: ev?.note ?? null,
  };
}
